import React, { useContext, useEffect, useState } from "react"
import { TransportOwnerContext } from "./TransportOwnerContext"
import "./transOwner.css"
import { useNavigate, Link, Outlet } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTachometerAlt,faSignOut, faUser} from '@fortawesome/free-solid-svg-icons';
import { fa } from '@fortawesome/free-solid-svg-icons';
export default function TransportOwnerDashboard() {  
  
  const {transportOwnerData } = useContext(TransportOwnerContext)
  const [dropDownView,setDropDownView]=useState(false)
  return (
    <div className="bg-gray-100  flex flex-col justify-between landing-page  italic mt-20">
      <div className=" relative  mt-4 " onMouseEnter={()=>setDropDownView(true)} onMouseLeave={()=>setDropDownView(false)}>
        <Link to="account" className=" hover:text-blue-500">
         {transportOwnerData?.profile?<img src={transportOwnerData?.profile} className=" h-20 w-20 rounded-full"/>:<FontAwesomeIcon icon={faUser} className=" w-12 h-12 rounded-full"/>}
        </Link>
       {dropDownView && <div className=" relative flex flex-col bg-white shadow-lg w-40 space-y-2 rounded-lg mx-4 mt-4 sm:text-sm md:font-semibold lg:text-lg">
         <Link to="account/change">
           <FontAwesomeIcon icon={faTachometerAlt}/>account
         </Link>
         <Link to="account/logout">
            <FontAwesomeIcon icon={faSignOut}/>logout
         </Link>
        </div>}
      </div>
      <p>Welcome {transportOwnerData?.username}</p>
      
      <div>
        <div className=" flex flex-row space-x-3 sm:text-sm md:font-semibold lg:text-lg">
          <Link to="transporters" className=" hover:text-blue-500">Transporters</Link>
          <Link to="communicate" className=" hover:text-blue-500">Communicate</Link>
        </div>
        <Outlet />
      </div>
    </div>

    
  )
}

